import {Component, Inject, OnInit} from '@angular/core';
import {Product} from '../../dto/product';
import {CardCancellationModel} from '../../models/card-cancellation-model';
import {ProductService} from '../../home/services/product.service';
import {CustomersService} from '../../home/services/customers.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CreateCardOrderModel} from '../../models/create-card-order-model';
import {CompanyService} from '../../home/services/company.service';
import {Company} from '../../dto/company';

@Component({
  selector: 'app-add-card-order-dialog',
  templateUrl: './add-card-order-dialog.component.html',
  styleUrls: ['./add-card-order-dialog.component.css']
})
export class AddCardOrderDialogComponent implements OnInit {
  title: string;
  text: string;
  product: Product|null = null;
  products: Product[] = [];
  comment = '';
  customerId: number;
  customerName: string;
  cardType = 1;
  companies: Company[] = [];
  company: Company|null = null;
  virtualOnly: boolean = false;


  constructor(
    private companyService: CompanyService,
    private productService: ProductService,
    public dialogRef: MatDialogRef<AddCardOrderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {

    this.customerId = this.data.customerId;
    this.title = this.data.title || 'TITLE_NOT_SET';
    this.text = this.data.text || 'TEXT_NOT_SET';
    this.companyService.getAll().subscribe(companies => this.companies = companies.data);

  }

  onYesClick(): void {
    const model = new CreateCardOrderModel();
    model.comment = this.comment;
    model.productId = this.product.id;
    model.customerId = this.customerId;
    model.cardType = this.cardType;
    model.virtualOnly = this.virtualOnly;

    this.dialogRef.close(model);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  companyChanged() {
    this.products =  [];
    this.product = null;
    this.productService.getForCompany(this.company.id).subscribe(c => {
      this.products = c;
    });
  }

}
